import React from 'react'

export default function navbar() {
 
  return (
    <div>
      <>
  <div className="container mt-3">
    <div className="row ">
      <nav class="navbar bg-light">
  <div class="container-fluid">
    <a class="navbar-brand" href="/">
      <img src={require('../assests/images/amd.png')} alt="" width="30" height="30" class="d-inline-block  mx-3 align-text-top"/>
      WEBINAR
    </a>
  </div>
</nav>
    </div>
  </div>
      </>
    </div>
  )
}
